(function () {

  // --------------------------
  // 1. CONFIG
  // --------------------------

  const currencySymbols = {
    AE: "AED", KW: "KWD", SA: "SAR", QA: "QAR",
    BH: "BHD", OM: "OMR", IN: "INR"
  };

  const countryToCurrency = {
    AE: "AED", KW: "KWD", SA: "SAR", QA: "QAR",
    BH: "BHD", OM: "OMR", IN: "INR"
  };

  const userCountry = window.shopifyCountry || "AE";
  const targetCurrency = countryToCurrency[userCountry] || "AED";

  // --------------------------
  // 2. GET EXCHANGE RATES
  // --------------------------

  let rates = { AED: 1 };

  if (window.exchangeRates && window.exchangeRates.rates) {
    rates = window.exchangeRates.rates;
  }

  const rate = Number(rates[targetCurrency]) || 1;
  const symbol = currencySymbols[userCountry] || "AED";

  // --------------------------
  // 3. PRICE CONVERSION (SAFE)
  // --------------------------

  function convertPriceElement(el) {
    if (!el || !el.textContent) return;
    if (!/\d/.test(el.textContent)) return;

    // Store base price once per element
    if (!el.dataset.basePrice) {
      const raw = el.textContent.replace(/[^0-9.,]/g, "");
      const normalized = raw.replace(/,/g, "");
      const base = parseFloat(normalized);

      if (isNaN(base)) return;

      el.dataset.basePrice = base;
    }

    const basePrice = parseFloat(el.dataset.basePrice);
    const converted = basePrice * rate;
const rounded = Math.round(converted);
el.textContent = rounded + " " + symbol;

  }

  // --------------------------
  // 4. CONVERT ALL PRICES
  // --------------------------

  function convertAllPrices() {
    const selectors = [
      ".product-price",
      ".price ins",
      ".price s",
      ".compare_prize",
      ".money",
      ".cart-drawer__total-price",
      ".cart-item__discounted-prices ins",
      ".cart-item__discounted-prices del",
      ".cart-item__price ins",
      ".cart-item__price del",
      ".cart-total",
      ".cart__summary-total-price",
      ".mini-cart__price",
      ".collection-item__price",
      ".grid-item__price"
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(convertPriceElement);
    });
  }

  // --------------------------
  // 5. INIT + SAFE OBSERVER
  // --------------------------

  document.addEventListener("DOMContentLoaded", convertAllPrices);

  let isRunning = false;

  const observer = new MutationObserver(() => {
    if (isRunning) return;

    isRunning = true;
    requestAnimationFrame(() => {
      convertAllPrices();
      isRunning = false;
    });
  });

  observer.observe(
    document.querySelector("main") || document.body,
    { childList: true, subtree: true }
  );

  document.addEventListener("variant:change", convertAllPrices);
  document.addEventListener("cart:updated", convertAllPrices);

})();
